/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiComponentType;
(function (ApiComponentType) {
    ApiComponentType["UNSPECIFIED"] = "ComponentType_Unspecified";
    ApiComponentType["LANDING"] = "ComponentType_Landing";
    ApiComponentType["LANDING_TEMPLATE"] = "ComponentType_LandingTemplate";
    ApiComponentType["LANDING_BLOCK"] = "ComponentType_LandingBlock";
    ApiComponentType["LANDING_COMPONENT"] = "ComponentType_LandingComponent";
})(ApiComponentType || (ApiComponentType = {}));
export function ApiComponentTypeFromJSON(json) {
    return ApiComponentTypeFromJSONTyped(json, false);
}
export function ApiComponentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiComponentTypeToJSON(value) {
    return value;
}
